import { render } from "./ApplicationPermission.vue?vue&type=template&id=580269b2&scoped=true"
import script from "./ApplicationPermission.vue?vue&type=script&lang=js"
export * from "./ApplicationPermission.vue?vue&type=script&lang=js"

import "./ApplicationPermission.vue?vue&type=style&index=0&id=580269b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580269b2"]])

export default __exports__